import { useApiQuery } from 'hooks/useApiQuery'
import { removeUndefined } from 'utils/util'

export const useGetNumberGrandPrizeEntries = ({
  contestId,
}: {
  contestId?: number
}) => {
  const queryArgs = removeUndefined({ contestId })

  return useApiQuery({
    method: 'get',
    path: '/admin/contests/entries/contest/{contestId}/total-entries',
    queryKey: ['/admin/contests/entries/contest/{contestId}/total-entries'],
    queryArgs,
  })
}
